/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import { IModelConnection, ScreenViewport } from "@itwin/core-frontend"; //!!OA

import { cRealityData } from "./RealityData";
import { cClassifier } from "./Classifier";
import { cSelection } from "./Selection";
import { cQuery } from "./Query";
import { cViewClip } from "./ViewClip";
import { cMessage } from "./Message";

export class cIndex {
  private static iModel: IModelConnection;
  private static sViewPort: ScreenViewport;
  private static rModelName: string;
  private static indexModel: string;

  public static initIndex(vp: ScreenViewport, imodel: IModelConnection, rModel: string) {
    console.log("initRealityModel");
    this.iModel = imodel;
    this.sViewPort = vp;
    this.indexModel = rModel;

    this.setIndexModel();
  }

  public static async setIndexModel(indexModel?: string) {
    const index = indexModel ?? cIndex.indexModel;
    if (index) {
      await cIndex.setSelectedModel(index, true, "$Index");
      cSelection.setOnElementSelected("index", cIndex.onIndexSelected);
    }
  }

  // !!! AH
  // If detach is set to true, the previous models will be removed and a new model will be reattached
  // eg, When Child model is previously selected and we need to select Parent Model
  public static async setSelectedModel(rmData: string, detach: boolean, classifier?: string) {
    const classifierModel = classifier ?? "$Elements";
    cMessage.showStatusBarMessage(`Loading ${rmData} model ...`, "icon-cloud-download");
    if (detach){
      console.log(detach);
      await cRealityData.removeRealityModel();
    }
    await cRealityData.attachRealityModel(rmData);

    cClassifier.addClassifiersToRealityData();
    cClassifier.setupClassifier(classifierModel);

    cSelection.setOnElementSelected("index");
  }
  // public static async setSelectedModel(rmData: string, classifier?: string) {
  //   const classifierModel = classifier ?? "$Elements";
  //   cMessage.showStatusBarMessage(
  //     `Loading ${rmData} model ...`,
  //     "icon-cloud-download"
  //   );

  //   await cRealityData.removeRealityModel();
  //   await cRealityData.attachRealityModel(rmData);

  //   cClassifier.addClassifiersToRealityData();
  //   cClassifier.setupClassifier(classifierModel);

  //   cSelection.setOnElementSelected("index");
  // }

  // Reference Function... Not being used
  public static async setMultipleModels(rmData: string, classifier?: string) {
    const classifierModel = classifier ?? "$Elements";
    cMessage.showStatusBarMessage(`Loading ${rmData} model ...`, "icon-cloud-download");

    //    await cRealityData.removeRealityModel();
    const activeModels = cRealityData.getActiveRealityModels();
    for (const model of activeModels.models) {
      if (model.name === "Central_2") {
        await cRealityData.detachRealityModelByName("Central_2");
      }
    }
    await cRealityData.attachRealityModel(rmData);

    cClassifier.addClassifiersToRealityData();
    cClassifier.setupClassifier(classifierModel);

    cSelection.setOnElementSelected("index");
  }

  public static async deselectModels() {
    await cRealityData.removeRealityModel();
  }

  public static async deselectById(id: number) {
    await cRealityData.detachRealityModelByIndex(id);
  }

  public static async deselectByName(name: string) {
    await cRealityData.detachRealityModelByName(name);
  }  

  public static async onIndexSelected(elementIds: string[]) {
    const rModel = new Map<string, string>();

//    const skidRM = await cQuery.getElementTag(elementIds[0]);
    const skidRM = elementIds[0];
    await cViewClip.clipToSelection();
    if (skidRM) {
      await cIndex.setSelectedModel(skidRM, true, "$Elements");
    } else {
      await cIndex.setSelectedModel("Central_2", true, "$Elements");
    }
    cMessage.clearStatusBarMessage();
  }
}
